const OMITTED_SCOPING_FILTERS = new Set([
  "slots_ui_start_date",
  "page",
  "per_page",
  "availability",
  "visit_types",
  "available_times",
  "available_date",
  "available_days",
]);

/** Returns declared option dependencies from editable values, excluding pagination, availability, and blank values. */
export function projectFinderScope(filterValues, dependencies) {
  if (typeof dependencies === "string") {
    dependencies = JSON.parse(dependencies);
  }

  let names = [];

  if (dependencies === true) {
    names = Object.keys(filterValues ?? {});
  } else if (Array.isArray(dependencies)) {
    names = dependencies;
  }

  const scope = {};

  for (const name of [...names].sort()) {
    const value = filterValues?.[name];

    if (!OMITTED_SCOPING_FILTERS.has(name) && value != null && value !== "") {
      scope[name] = value;
    }
  }

  return scope;
}
